import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store/index'

// Customer Components
import Account from '../views/Account.vue'
import Checkout from '../views/Checkout.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import NotFound from '../views/NotFound.vue'
import ProductDetail from '../views/ProductDetail.vue'
import Products from '../views/Products.vue'
import Register from '../views/Register.vue'
import ResetPassword from '../views/ResetPassword.vue'

// Admin Components
import Admin from '../views/admin/Admin.vue'
import Advisors from '../views/admin/Advisors.vue'
import Audience from '../views/admin/Audience.vue'
import Behaviour from '../views/admin/Behaviour.vue'
import Customers from '../views/admin/Customers.vue'
import CustomerAccounts from '../views/admin/CustomerAccounts.vue'
import DealerProducts from '../views/admin/DealerProducts.vue'
import DealerSettings from '../views/admin/DealerSettings.vue'
import ManufacturerProducts from '../views/admin/ManufacturerProducts.vue'
import Orders from '../views/admin/Orders.vue'
import Sales from '../views/admin/Sales.vue'
import Users from '../views/admin/Users.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/:makeId/:dealerCode',
    name: 'Home',
    component: Home
  },
  {
    path: '/:makeId/:dealerCode/login',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      const isLoggedIn = store.getters['auth/authenticated']
      if (isLoggedIn) {
        next({ name: 'Account', params: {...{redirect: to.name}, ...to.params} })
      } else {
        next()
      }
    }
  },
  {
    path: '/:makeId/:dealerCode/register',
    name: 'Register',
    component: Register,
    beforeEnter: (to, from, next) => {
      const isLoggedIn = store.getters['auth/authenticated']
      if (isLoggedIn) {
        next({ name: 'Account', params: {...{redirect: to.name}, ...to.params} })
      } else {
        next()
      }
    }
    
  },
  {
    path: '/:makeId/:dealerCode/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/:makeId/:dealerCode/account',
    name: 'Account',
    component: Account,
    beforeEnter: (to, from, next) => {
      const isAuth = store.getters['auth/authenticated']
      if (!isAuth) next({ name: 'Login', params: {...{redirect: to.name}, ...to.params}})
      else next()
    }
  },
  {
    path: '/:makeId/:dealerCode/products',
    name: 'Products',
    component: Products
  },
  {
    path: '/:makeId/:dealerCode/checkout',
    name: 'Checkout',
    component: Checkout,
    props: true,
    beforeEnter: (to, from, next) => {
      const cartProducts = store.getters['cart/products']
      const emptyCart = cartProducts.length > 0 ? false : true
      to.params.emptyCart = emptyCart
      next()
    }
  },
  {
    path: '/:makeId/:dealerCode/products/:productId',
    name: 'Product Detail',
    props: (params) => {
      ({ 
        productId: Number.parseInt(params.productId, 10) || 0,
      })
    },
    component: ProductDetail
  },
  {
    path: '/:makeId/:dealerCode/admin',
    name: 'Admin',
    component: Admin,
    redirect: '/:makeId/:dealerCode/admin/sales',
    children: [
      {
        path: 'advisors',
        name: 'Advisors',
        component: Advisors
      },
      {
        path: 'audience',
        name: 'Audience',
        component: Audience
      },
      {
        path: 'behaviour',
        name: 'Behaviour',
        component: Behaviour
      },
      {
        path: 'customers',
        name: 'Customers',
        component: Customers
      },
      {
        path: 'customer-accounts',
        name:'Customer Accounts',
        component: CustomerAccounts
      },
      {
        path: 'dealer-products',
        name: 'Dealer Products',
        component: DealerProducts,
        props: {
          productType: 'Dealer'
        }
      },
      {
        path: 'dealer-settings',
        name: 'Dealer Settings',
        component: DealerSettings
      },
      {
        path: 'manufacturer-products',
        name: 'Manufacturer Products',
        component: ManufacturerProducts,
        props: {
          productType: 'Manufacturer'
        }
      },
      {
        path: 'orders',
        name: 'Orders',
        component: Orders
      },
      {
        path: 'sales',
        name: 'Sales',
        component: Sales
      },
      {
        path: 'users',
        name: 'Users',
        component: Users
      }
    ]
  },
  {
    path: '/:makeId/:dealerCode/404',
    name: 'Not Found',
    component: NotFound
  },
  {
    path: '*',
    component: NotFound,
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (['Admin', 'Advisors', 'Audience', 'Behaviour', 'Customers', 'Customer Accounts', 'Dealer Products', 'Dealer Settings', 'Manufacturer Products', 'Orders', 'Sales', 'Users'].includes(to.name)) {
    const isDealerAdmin = store.getters['auth/isDealerAdmin']
    const isAuth = store.getters['auth/authenticated']
    if (!isAuth && !isDealerAdmin) next({ name: 'Login', params: {...{redirect: to.name}, ...to.params}, query: { redirect: '/' + to.params.makeId + '/' + to.params.dealerCode + '/admin' } })
    else if (isAuth && !isDealerAdmin) next({ name: 'Account', params: {...{redirect: to.name}, ...to.params} })
    else next()
  } else {
    next()
  }
})

export default router
